/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drastic_Tech_Target_Folder_HelpInputs */



/**
* | output |
* | --- |
* | "Select a target location that is used for the final outputs." |
*
* @param {Drastic_Tech_Target_Folder_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_target_folder_help = /** @type {((inputs?: Drastic_Tech_Target_Folder_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Target_Folder_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Selectionnez un emplacement cible utilise pour les sorties finales.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie einen Zielort aus, der für die endgültigen Ausgaben verwendet wird.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Selezionare una posizione di destinazione da utilizzare per gli output finali.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите целевое местоположение, которое будет использоваться для получения окончательных результатов.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione una ubicación de destino que se utilizará para los resultados finales.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择最终输出的目标位置。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("最終出力に使用するターゲットの場所を選択します。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अंतिम आउटपुट के लिए उपयोग किए जाने वाले लक्ष्य स्थान का चयन करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione um local de destino que será usado para os resultados finais.")
	return /** @type {LocalizedString} */ ("Select a target location that is used for the final outputs.")
});